export function  decodeShopFromIP(ip) {
    console.log("Decoding shop number from IP:", ip);
    if (!ip) return null;
    const parts = ip.split(".");
    if (parts.length !== 4) return null;
    let temp = parts[2].length === 1 ? "0" + parts[2] : parts[2];
    temp = parts[1] + temp;
    const shopNumber = parseInt(temp, 10) - 4000;

    return shopNumber.toString().padStart(4, "0");
  }